module.exports = __webpack_public_path__ + "img/xiaohe.3ad9edc0.png";